import { fileUpload, getRequest, postRequest } from './request'

export function createApp (appForm) {
  return postRequest('/app/create', appForm)
}

export function createAppVersion (appVersionForm) {
  return postRequest('/app/version/create', appVersionForm)
}

export function deleteApp (id) {
  return postRequest('/app/delete', { 'id': id })
}

export function deleteAppVersion (id) {
  return postRequest('/app/version/delete', { 'id': id })
}

export function getAppList () {
  return getRequest('/app/list', {})
}

export function getAppVersionList (appId) {
  return getRequest('/app/version/list', { 'appId': appId })
}

export function getAndroidUrl (appId) {
  return getRequest('/app/android/url', {})
}

